import React, { useState } from 'react';
import {useHistory, useParams} from 'react-router-dom';
import { MDBBtn, MDBCard, MDBCardBody, MDBCheckbox, MDBContainer, MDBInput, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from "mdb-react-ui-kit";
import axios from 'axios';

function QrEventParticipantRequestForm() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [affiliation, setAffiliation] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [gender, setGender] = useState('');
    const [consent, setConsent] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [contactError, setContactError] = useState('');
    const [genderError, setGenderError] = useState('');
    const [modalOpen, setModalOpen] = useState(false); // Modal 상태
    const history = useHistory();
    const { eventName } = useParams();

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const validateContactNumber = (number) => /^\d{3}-\d{4}-\d{4}$/.test(number);

    const handleContactNumberChange = (e) => {
        let value = e.target.value.replace(/[^0-9]/g, '');
        if (value.length > 3 && value.length <= 7) {
            value = `${value.slice(0, 3)}-${value.slice(3)}`;
        } else if (value.length > 7) {
            value = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 11)}`;
        }
        setContactNumber(value);
        setContactError(validateContactNumber(value) ? '' : '전화번호를 000-0000-0000 형식으로 입력해 주세요.');
    };

    const handleSubmit = async () => {
        if (!consent) {
            alert("개인정보 이용에 동의해 주세요.");
            return;
        }

        if (!validateEmail(email)) {
            setEmailError("올바른 이메일 형식을 입력해 주세요.");
            return;
        } else {
            setEmailError('');
        }

        if (!validateContactNumber(contactNumber)) {
            setContactError("전화번호를 000-0000-0000 형식으로 입력해 주세요.");
            return;
        } else {
            setContactError('');
        }

        if (!gender) {
            setGenderError("성별을 선택해 주세요.");
            return;
        } else {
            setGenderError('');
        }

        const decodedEventName = eventName.replaceAll('_', ' ');

        const participantData = {
            name,
            email,
            affiliation,
            contactNumber,
            gender,
            eventName: decodedEventName
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_REAL_URL}/public/qr-event-participant/register`, {
                eventName: decodedEventName,
                participant: participantData
            });


            if (response.status === 200) {
                alert('참가 신청이 성공적으로 접수되었습니다.');
                history.push('/qr-event-participant-my-view', {
                        uuid: response.data,
                        name,
                        affiliation,
                        contactNumber,
                        email,
                        eventName
                });
            }
        } catch (error) {
            if (error.response) {
                alert("중복 참가 신청이거나 유효하지 않은 정보입니다.");
            } else if (error.request) {
                alert('서버와의 통신에 문제가 발생했습니다.');
            } else {
                alert('요청 중 오류가 발생했습니다.');
            }
            console.error('Error:', error);
        }
    };

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleConsentClick = () => {
        // 체크박스 클릭 시 모달을 열고 체크박스 상태는 변경하지 않음
        toggleModal();
    };

    const handleModalClose = () => {
        setConsent(true); // 모달이 닫힐 때 체크박스를 체크 상태로 변경
        toggleModal();
    };

    return (
        <MDBContainer fluid className='d-flex align-items-center justify-content-center bg-image' style={{ backgroundImage: 'url(https://mdbcdn.b-cdn.net/img/Photos/new-templates/search-box/img4.webp)', paddingTop: "50px" }}>
            <div className='mask gradient-custom-3'></div>

            <MDBCard className='m-5' style={{ maxWidth: '500px', minWidth: '340px' }}>
                <MDBCardBody className='px-5'>
                    <h4 className="text-uppercase text-center mb-5">{eventName.replaceAll('_', ' ')}</h4>
                    <MDBInput wrapperClass='mb-4' label='성함' size='lg' value={name} onChange={(e) => setName(e.target.value)} type='text' required />
                    <div className='mb-4'>
                        <MDBInput label='이메일' placeholder='onnme@gmail.com' size='lg' value={email} onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailError(validateEmail(e.target.value) ? '' : '올바른 이메일 형식을 입력해 주세요.');
                        }} type='email' required />
                        {emailError && <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{emailError}</p>}
                    </div>
                    <MDBInput wrapperClass='mb-4' label='소속' placeholder='없을 경우 X' size='lg' value={affiliation} onChange={(e) => setAffiliation(e.target.value)} type='text' required />
                    <div className='mb-4'>
                        <MDBInput label='연락처' placeholder='010-0000-0000' size='lg' value={contactNumber} onChange={handleContactNumberChange} type='text' required />
                        {contactError && <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{contactError}</p>}
                    </div>
                    <div className='mb-4'>
                        <select className='form-select' value={gender} onChange={(e) => setGender(e.target.value)} required>
                            <option value='' disabled>성별</option>
                            <option value='남'>남</option>
                            <option value='여'>여</option>
                        </select>
                        {genderError && <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{genderError}</p>}
                    </div>
                    <div className='d-flex flex-row justify-content-center mb-4'>
                        <MDBCheckbox name='flexCheck' id='flexCheckDefault' label='개인정보 이용에 동의합니다' checked={consent} onChange={handleConsentClick} required />
                    </div>
                    <MDBBtn className='mb-4 w-100 gradient-custom-4' size='lg' onClick={handleSubmit}>참가 신청</MDBBtn>
                </MDBCardBody>
            </MDBCard>

            {/* 개인정보 처리방침 Modal */}
            <MDBModal open={modalOpen} setShow={setModalOpen} tabIndex='-1'>
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>개인정보 이용 및 처리방침</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={handleModalClose}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>㈜온앤미는 정보주체의 자유와 권리보호를 위해 「개인정보보호법」 및 관계
                                법령이 정한 바를 준수하고 있습니다. 이에 「개인정보보호법」 제 30조에 따라
                                용역업무 및 기타 대행업무 수행과정에서 습득한 개인정보 이용 및
                                처리기준을 다음과 같이 수립·공개합니다.</p>
                            <p>1. 정보 범위: 성명, 개인 연락처, 이메일, 주소, 아이디 등</p>
                            <p>2. 이용 목적: 프로그램 모집 및 홍보, 이벤트 진행 등 용역업무 수행</p>
                            <p>3. 이용 매체: 명단 등록·관리 웹서비스, 문서 등</p>
                            <p>4. 보유 기간: 습득일 기준 3년</p>
                            <p>5. 처리 위탁: 가명처리 관련, 코드 변환, 웹서비스 운영 및 유지관리 등</p>
                            <p>6. 이 용 자: ㈜온앤미</p>

                            <p>《제 3자 제공에 관한 사항》
                                ㈜온앤미는 정보주체의 동의, 법률의 특별한 규정 등 「개인정보보호법」 제
                                17조 및 제 18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>

                            <p>㈜온앤미는 정보주체의 자유와 권리보호를 위해 「개인정보보호법」 및 관계
                                법령이 정한 바를 준수하고 있습니다. 이에 「개인정보보호법」 제 30조에 따라
                                용역업무 및 기타 대행업무 수행과정에서 습득한 개인정보 이용 및
                                처리기준을 다음과 같이 수립·공개합니다.</p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' onClick={handleModalClose}>확인</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </MDBContainer>
    );
}

export default QrEventParticipantRequestForm;